module.exports = __webpack_public_path__ + "static/img/ML.a52b66a5.svg";